module.exports = __webpack_public_path__ + "eg.4263356b4f839970c2b6.svg";


//////////////////
// WEBPACK FOOTER
// C:/xampp/htdocs/sm8-v1-front/src/scss/icons/flag-icon-css/flags/eg.svg
// module id = ../../../../../src/scss/icons/flag-icon-css/flags/eg.svg
// module chunks = styles